import React from 'react';
import { XCircle } from '../../../icons/icons';

interface ListItemButtonProps {
  isSelected?: boolean;
  onClick: () => void;
  onRemove?: () => void;
  children: React.ReactNode;
}

export const ListItemButton: React.FC<ListItemButtonProps> = ({
  isSelected = false,
  onClick,
  onRemove,
  children,
}) => {
  return (
    <li
        className='flex items-center justify-between px-4 py-2 rounded-md hover:bg-gray-100 transition cursor-pointer'
        onClick={onClick}
    >
      <div className='flex items-center gap-3 flex-1'>{ children }</div>
      { isSelected && onRemove ? (
        <button
            onClick={(e) => {
              e.stopPropagation(); // prevent parent click
              onRemove();
            }}
            className='p-1 text-gray-500 hover:text-red-500 transition'
        >
          <XCircle />
        </button>
      ) : null }
    </li>
  );
};
